import React from "react";

function SkeletonField({ fullWidth = false }) {
  return (
    <div className={`flex min-w-0 flex-col gap-1.5${fullWidth ? " lg:col-span-full" : ""}`}>
      <div className="h-4 w-24 animate-pulse rounded bg-gray-200" />
      <div className="h-10 w-full animate-pulse rounded-lg bg-gray-200" />
    </div>
  );
}

function ProviderFormSkeleton() {
  return (
    <div className="flex w-full flex-col gap-6">
      <div className="grid w-full grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        {[...Array(4)].map((_, index) => (
          <SkeletonField key={`main-${index}`} />
        ))}
      </div>

      <div className="flex w-full flex-col gap-4">
        <div className="h-4 w-40 animate-pulse rounded bg-gray-200" />
        <div className="rounded-lg border border-gray-100 bg-slate-50 p-4">
          <div className="grid w-full grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-5">
            {[...Array(5)].map((_, index) => (
              <SkeletonField key={`contact-${index}`} />
            ))}
          </div>
        </div>
      </div>

      <div className="flex w-full flex-col gap-4">
        <div className="h-4 w-44 animate-pulse rounded bg-gray-200" />
        <SkeletonField fullWidth />
      </div>
    </div>
  );
}

export default ProviderFormSkeleton;
